module.exports = __webpack_public_path__ + "static/fonts/PorscheNextTT-ThinBold.b2371728.ttf";